import { initBootstrapConfig } from './app/infra/bootstrap-config';

// Populate the bootstrap config (async fetch, no sync XHR) before loading Angular so consumers
// read a fully-initialized config.
initBootstrapConfig()
	.then(() => import('./bootstrap'))
	.catch(err => console.error(err));
